export default {
  discount_badge: '{{value}} Rabatt',
  high_caffeine_warning_required: 'Enthält Koffein',
  pfand: 'Inkl. {{value}} Pfand',
  alcohol_by_volume_percent: '{{value}} % Vol. Alkohol',
};
